const CustomRegionOption = ({ children, darkMode, ...props }) => {
    const isSelected = props.isSelected;
    const isFocused = props.isFocused;
    const isDisabled = props.isDisabled;

    return (
        <div
            {...props.innerProps}
            style={{
                ...props.getStyles('option', props),
                padding: '8px 12px',
                borderBottom: '1px solid ' + (darkMode ? '#444' : '#eee'),
                backgroundColor: isSelected
                    ? 'var(--chakra-colors-brand-500)'
                    : isFocused
                      ? darkMode
                          ? 'rgba(255, 255, 255, 0.16)'
                          : '#f5f5f5'
                      : 'transparent',
                color: isSelected
                    ? 'white'
                    : isDisabled
                      ? 'rgb(204,204,204)'
                      : 'inherit',
            }}
            title={
                isDisabled
                    ? 'This region already has a cluster. Only one cluster per region is allowed.'
                    : `Select ${props.data.name} region`
            }>
            {children}
        </div>
    );
};
export { CustomRegionOption };
